import { FC } from "react";
import type { RaffleVisibility } from "entities/wheel-raffle";
import { FormInput, Tabs } from "shared/ui";
import type { TabItem } from "shared/ui";
import type { CreateRaffleForm } from "../model/useCreateRaffle";
import { LabeledInput } from "./LabeledInput";

import styles from "./CreateWheelRaffleForm.module.css";

interface Props {
  form: CreateRaffleForm;
}

const VISIBILITY_TABS: TabItem<RaffleVisibility>[] = [
  { value: "open", label: "Open" },
  { value: "private", label: "Private" },
];

const HINTS: Record<RaffleVisibility, string> = {
  open: "Shown to everyone. Users who meet the conditions join automatically.",
  private: "Hidden from the list. Users join only with the invite code.",
};

export const VisibilityFields: FC<Props> = ({ form }) => {
  const { values, errors, setValue, isSubmitting } = form;

  return (
    <>
      <LabeledInput label="Promo type" hint={HINTS[values.visibility]}>
        <Tabs
          items={VISIBILITY_TABS}
          active={values.visibility}
          onChange={(visibility) => setValue("visibility", visibility)}
          activeClassName={styles.activeTab}
        />
      </LabeledInput>
      {values.visibility === "private" && (
        <LabeledInput
          label="Invite code"
          hint="Share it with the users you want to invite."
        >
          <FormInput
            placeholder="SUMMER2026"
            value={values.inviteCode}
            error={errors.inviteCode}
            onValueChange={(value) => setValue("inviteCode", value)}
            disabled={isSubmitting}
          />
        </LabeledInput>
      )}
    </>
  );
};
